import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { QuizEvent } from "../enums/quiz-event.enum";
import { useAppSelector } from "./redux.hook";
import { postMessageService } from "../services/post-message.service";
import { setPolicyAgreeStatus } from "../redux/service-slice";

export const usePolicyAgree = () => {
  const { policyAgree: policyStatus } = useAppSelector(state => state.service) || {};
  const { policyAgreementMode } = useAppSelector(state => state.settings) || {};
  const dispatch = useDispatch();

  const setPolicyAgree = useCallback(() => {
    postMessageService.send({ event: QuizEvent.CLICK_POLICY_AGREE });
    dispatch(setPolicyAgreeStatus());
  }, [dispatch]);

  return { policyStatus, policyAgreementMode, setPolicyAgree };
};
